export default {
  header: 'Musimy zweryfikować Twój numer telefonu',
  buttons: {
    confirm: 'Potwierdź',
  },
  toasts: {
    invalid_code: 'Nieprawidłowy kod. Spróbuj ponownie.',
  },
};
